import React from 'react'
import _ from 'lodash'
import { isImmutable, Map, List } from 'immutable'
import { processShowModal } from '../../../../store/project/processShowModal'
import { getParams, getState } from '../../../../lib/processPortalRules'

const toJS = (val) => (isImmutable(val) ? val.toJS() : val)

export function getBrowserLocales(options = {}) {
  const defaultOptions = {
    languageCodeOnly: false,
  }

  const opt = {
    ...defaultOptions,
    ...options,
  }

  if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
    const browserLocales = navigator.languages === undefined ? [navigator.language] : navigator.languages

    if (!browserLocales) {
      return undefined
    }

    return _.filter(
      browserLocales.map((locale) => {
        const trimmedLocale = locale.trim()

        return opt.languageCodeOnly ? trimmedLocale.split(/-|_/)[0] : trimmedLocale
      }),
      (v) => v !== 'en-US'
    ) //moment not have it.
  } else {
    return undefined
  }
}

export const toColor = (color) => {
  if (/^[a-f0-9]{3}|[a-f0-9]{6}|[a-f0-9]{8}$/i.test(color) && String(color).indexOf('#') === -1) {
    return `#${color}`
  } else {
    return color
  }
}

export function clearStringStyle(str) {
  let div = document.createElement('div')
  div.innerHTML = str
  remove_style(div)
  return div.innerHTML
}

export function remove_style(all) {
  const attr = [
    'align',
    'background',
    'bgcolor',
    'border',
    'cellpadding',
    'cellspacing',
    'color',
    'face',
    'height',
    'hspace',
    'marginheight',
    'marginwidth',
    'noshade',
    'nowrap',
    'valign',
    'vspace',
    'width',
    'vlink',
    'alink',
    'text',
    'link',
    'frame',
    'frameborder',
    'clear',
    'scrolling',
    'style',
  ]
  if (all) {
    _.each(attr, (v) => {
      if (all.removeAttribute && all.removeChild) {
        all.removeAttribute(v)
      }
    })
    if (all.childNodes) {
      if (typeof all.childNodes.forEach === 'function') {
        all.childNodes.forEach(remove_style)
      } else {
        _.forEach(all.childNodes, remove_style)
      }
    }
  }
}

export function remove_badClassName(all) {
  if (all) {
    if (all.classList && all.classList.contains('ft--component-wrap')) {
      all.classList.remove('ft--component-wrap')
    }
    if (all.childNodes) {
      if (typeof all.childNodes.forEach === 'function') {
        all.childNodes.forEach(remove_badClassName)
      } else {
        _.forEach(all.childNodes, remove_badClassName)
      }
    }
  }
}

export const detFloatValue = (component, path, valueDefault = 0) => {
  const value = parseFloat(String(component.getIn(path, valueDefault)).replace(/(,)/g, '.'))
  return _.isNaN(value) ? valueDefault : value
}

export const detIntValue = (component, path, valueDefault = 0) => {
  const value = parseInt(component.getIn(path, valueDefault), 10)
  return _.isNaN(value) ? valueDefault : value
}

const colorStyleActionHandlers = {
  /** @returns {React.CSSProperties} */
  bg: ({ isSvg, value }) => (isSvg ? { fill: toColor(value) } : { backgroundColor: toColor(value) }),
  /** @returns {React.CSSProperties} */
  color: ({ isSvg, value }) => (isSvg ? { stroke: toColor(value) } : { color: toColor(value) }),
  /** @returns {React.CSSProperties} */
  border: ({ isSvg, value }) => (isSvg ? { stroke: toColor(value) } : { borderColor: toColor(value) }),
}

/** @returns {React.CSSProperties} */
export const getStyleActions = (actions, isSvg = false, isPowerTable = false) =>
  actions?.flat(Infinity)?.reduce(
    /** @type {(style: React.CSSProperties, rawAction: string) => React.CSSProperties} */
    (style, rawAction) => {
      const stringified = String(rawAction)
      const parts = stringified.split('_')
      const action = _.first(parts)
      const value = _.last(parts)

      if (action === 'hide' && isPowerTable) {
        return {
          ...style,
          opacity: '0',
          pointerEvents: 'none',
        }
      }
      const handler = colorStyleActionHandlers[action]

      if (!handler) return style

      return {
        ...style,
        ...handler({ isSvg, value }),
      }
    },
    {}
  )

export const getDisplayFromActions = (actions, isPreview) => {
  if (actions.indexOf('hide') !== -1) {
    if (isPreview) {
      return { visibility: 'hidden' }
    } else {
      return { opacity: 0.4 }
    }
  }
  if (actions.indexOf('show') !== -1) {
    return {
      visibility: 'visible',
    }
  }
  return {}
}

export const processRedirect = (redirectProps, widgetPathProvided, state, dispatch) => {
  const isPortal = Boolean(_.get(window.__FT_APP_STATE__, 'portal'))
  let index = _.findLastIndex(widgetPathProvided, (s) => _.startsWith(s, 'i?'))
  const widgetPath = index === -1 ? widgetPathProvided : _.slice(widgetPathProvided, 0, index - 1)
  const currentPath = isPortal ? _.initial(widgetPath) : _.tail(widgetPath)
  const repeatIndex = _.find(_.reverse([...widgetPathProvided]), (s) => _.startsWith(s, 'i?'))
  const currentState = currentPath.length > 0 ? _.get(getState(state), currentPath, {}) : getState(state)
  const currentParams = currentPath.length > 0 ? _.get(getParams(state), currentPath, {}) : getParams(state)
  const target = redirectProps.get('target', 'self')
  const redirect = toJS(redirectProps.get('redirect', { value: 'other' })).value
  let otherURL = ''
  if (redirect === 'other') {
    otherURL = redirectProps.get('customURL', '')
  } else {
    if (toJS(redirectProps.get('redirect', { value: 'other' })).group === 'param') {
      otherURL = _.get(currentParams, redirect.split(':'), '')
    } else {
      otherURL = _.get(
        currentState,
        String(redirect)
          .replace('CWDB:', '')
          .replace(/REPEAT/, repeatIndex)
          .split(':'),
        ''
      )
    }
  }
  const modalParams = {}
  redirectProps.get('redirectParams', Map()).map((name, field) => {
    if (name && String(name).length > 0) {
      const [fieldKey, group] = String(field).split('##-##')
      if (group === 'param') {
        modalParams[name] = _.get(currentParams, String(fieldKey).replace('CWDB:', '').replace(/\:/g, '.'), '')
      } else {
        modalParams[name] = _.get(
          currentState,
          String(fieldKey)
            .replace('CWDB:', '')
            .replace(/REPEAT/, repeatIndex)
            .split(':'),
          ''
        )
      }
    }
  })
  const params = []
  _.each(modalParams, (v, k) => params.push(`${k}=${encodeURIComponent(v)}`))
  if (target === 'self') {
    window.location.href = otherURL + (String(otherURL).indexOf('?') === -1 ? '?' : '&') + params.join('&')
  } else if (target === 'parent') {
    if (window.parent) {
      window.parent.location.href = otherURL + (String(otherURL).indexOf('?') === -1 ? '?' : '&') + params.join('&')
    }
  } else if (target === 'blank') {
    window.open(otherURL + (String(otherURL).indexOf('?') === -1 ? '?' : '&') + params.join('&'), 'blank')
  } else if (target === 'modal') {
    dispatch(
      processShowModal({
        url: otherURL,
        width: redirectProps.get('width', ''),
        height: redirectProps.get('height', ''),
        params: params,
      })
    )
  } else {
    console.log('bad target')
  }
}

export const formatComponentText = (text, withoutFixObject, simpleJoin) => {
  let localText = text
  if (typeof text == 'string') {
    return text
  } else if (isImmutable(localText)) {
    localText = localText.toJS()
  }

  if (_.isArray(localText)) {
    return localText.join(simpleJoin ? ' ' : ',')
  } else if (localText && _.isObject(localText) && !withoutFixObject) {
    return _.compact(Object.values(localText)).join(simpleJoin ? ' ' : ', ')
  }
  return localText
}

export const clearHTML = (txt) => {
  let node = document.createElement('div')
  node.innerHTML = txt
  return node.textContent
}

export const getAllChildren = (list, elements) => {
  let result = [...list]
  _.each(list, function (uid) {
    if (elements) {
      let elem = elements.get(uid)
      if (elem && elem.get('children')) {
        let subResult = getAllChildren(elem.get('children', List()).toJS(), elements)
        result = result.concat(subResult)
      }
    }
  })
  return result
}

export const getAllVisibleChildren = (list, elements, rules) => {
  let result = [...list]
  _.each(list, function (uid) {
    if (elements) {
      try {
        if (rules.get(uid) && isImmutable(rules.get(uid)) && rules.get(uid, List()).indexOf) {
          if (rules.get(uid, List()).indexOf('hide') > -1) {
            return true
          }
        }
      } catch (err) {
        console.error(err)
      }
      let elem = elements.get(uid)
      if (elem && elem.get('children')) {
        let subResult = getAllChildren(elem.get('children').toJS(), elements)
        result = result.concat(subResult)
      }
    }
  })
  return result
}
